export const routeConstants = {
  ROOT: {
    path: '/',
    name: 'root'
  },
  LOGIN: {
    path: '/login',
    name: 'login',
    title: 'Login'
  },
  LOGOUT: {
    path: '/logout',
    name: 'logout',
    title: 'Logging out...'
  },
  STUDYPAGES_LOGIN_SUCCESS: {
    path: '/studypages/success',
    name: 'studypage-success',
    title: 'Signing In...'
  },
  STUDY_REDIRECT: {
    path: '/investigation/:studyId',
    name: 'study-redirect',
    title: 'Redirecting...'
  },
  ECONSENT_VERIFICATION: {
    path: '/e-consent-verification',
    name: 'eConsent-redirect',
    title: 'Redirecting...'
  },
  JOIN_STUDY: {
    path: '/join',
    name: 'join-study',
    title: 'Join Study'
  },
  SIGNUP: {
    path: '/signup',
    name: 'signup',
    title: 'Sign Up'
  },
  ONBOARDING: {
    path: '/onboarding',
    name: 'onboarding',
    title: 'Onboarding'
  },
  PUBLIC_FORM: {
    path: '/form/:formIdentifier',
    name: 'publicForm',
    title: 'Entry'
  },
  STUDY_PUBLIC_FORM: {
    path: '/study/:studyIdentifier/form/:formIdentifier',
    name: 'studyPublicForm',
    title: 'Entry'
  },
  PRINT_FORM: {
    path: '/form/:formIdentifier/print',
    name: 'printForm',
    title: 'Print Form'
  },
  STUDY_FETCH: {
    path: '/study',
    name: 'studyFetchContainer',
    title: 'Loading Study...'
  },
  DASHBOARD: {
    path: 'dash',
    name: 'dashboardContainer'
  },
  DATA: {
    path: 'data',
    name: 'data',
    title: 'Data'
  },
  ARCHIVE: {
    path: 'archive',
    name: 'archive',
    title: 'Archive'
  },
  FORMS: {
    path: 'forms',
    name: 'forms',
    title: 'Forms'
  },
  FORM_BUILDER: {
    path: 'form/:identifier',
    name: 'formBuilder',
    title: 'Edit Form'
  },
  CASES: {
    path: 'cases',
    name: 'caseList',
    title: 'Data'
  },
  CASES_PIPELINE: {
    path: 'cases/pipeline',
    name: 'casesPipeline',
    title: 'Data'
  },
  CASE_ENTRIES: {
    path: 'cases/entries',
    name: 'casesEntryList',
    title: 'Data'
  },
  CASE: {
    path: 'case/:identifier',
    name: 'case',
    title: 'Data'
  },
  CASE_NEW_ENTRY: {
    path: 'form/:formIdentifier/entry/new',
    name: 'caseNewEntry',
    title: 'Data'
  },
  CASE_ENTRY: {
    path: 'form/:formIdentifier/entry/:entryIdentifier',
    name: 'caseEntry',
    title: 'Data'
  },
  ENTRIES: {
    path: 'entries',
    name: 'entryList',
    title: 'Data'
  },
  NEW_ENTRY: {
    path: 'form/:formIdentifier/entry/new',
    name: 'newEntry',
    title: 'Data'
  },
  ENTRY: {
    path: 'form/:formIdentifier/entry/:entryIdentifier',
    name: 'entry',
    title: 'Data'
  },
  EXPORT: {
    path: 'export',
    name: 'export',
    title: 'Export'
  },
  ACTIVITY: {
    path: 'activity',
    name: 'activity',
    title: 'Activity'
  },
  ANALYTICS: {
    path: 'analytics',
    name: 'analytics',
    title: 'Analytics'
  },
  MANAGE: {
    path: 'manage',
    name: 'manage',
    title: 'Users'
  },
  STUDY_SETTINGS: {
    path: 'study_settings',
    name: 'studySettings',
    title: 'Study Settings'
  },
  PART_11_PIN_SETUP: {
    path: 'part11pin',
    name: 'part11PinSetup',
    title: 'Part 11 PIN Setup'
  },
  ACCOUNT_SETTINGS: {
    path: 'accountSettings',
    name: 'accountSettings',
    title: 'Account Settings'
  },
  /**
   * The notification centre. Sits under the study dashboard like every other
   * route here, and the list is scoped to the selected study by default —
   * `transformDeepLink` only ever produces study-scoped paths, so a notification
   * opened from outside one has nowhere to navigate to.
   */
  NOTIFICATIONS: {
    path: 'notifications',
    name: 'notifications',
    title: 'Notifications'
  },
  STUDY_CREATE: {
    path: 'studyCreate',
    name: 'studyCreate',
    title: 'Create Study'
  },
  /**
   * Three places decide "this URL is the perfusion dashboard", and only one of them can import
   * this file: `main.ts` matches on the route names below to drop the tier-0 silhouette, and
   * `index.html` matches the `surgeon-dashboard` path segment inline, before any bundle exists.
   * Rename the segment and that inline check in `index.html` goes quietly false.
   */
  SURGEON_DASHBOARD: {
    path: 'surgeon-dashboard',
    name: 'surgeon-dashboard',
    title: 'Surgeon Dashboard'
  },
  DEFAULT_SURGEON_DASHBOARD: {
    path: 'surgeon-dashboard',
    name: 'default-surgeon-dashboard',
    title: 'Surgeon Dashboard'
  },
  CASE_SURGEON_DASHBOARD: {
    path: ':caseId',
    name: 'case-surgeon-dashboard',
    title: 'Surgeon Dashboard'
  },
  INTERACTIVE_SURGEON_DASHBOARD: {
    path: ':caseId/interactive',
    name: 'interactive-surgeon-dashboard',
    title: 'Surgeon Dashboard'
  },
  PUMP_QC_REPORT: {
    path: 'pump-qc-report',
    name: 'pump-qc-report',
    title: 'PUMP QC Report'
  },
  MOBILE_AUTH: {
    path: '/mobile-auth',
    name: 'mobile-auth',
    title: 'Mobile Authentication'
  }
};

export const ADJECTIVES = [
  'neat',
  'crisp',
  'slick',
  'smart',
  'awesome',
  'phenomenal',
  'fabulous',
  'elegant',
  'smooth',
  'creative',
  'imaginative',
  'innovative',
  'inventive',
  'original',
  'inspiring',
  'fanciful',
  'fantastic',
  'whimsical',
  'innovational',
  'fresh',
  'fancy',
  'experimental',
  'chimeric',
  'revolutionary',
  'phantasmic',
  'astute',
  'insightful',
  'inspirational',
  'pioneering',
  'trailblazing',
  'transformational',
  'visionary',
  'bright',
  'intelligent',
  'clever',
  'wise',
  'brainy',
  'brilliant',
  'savvy',
  'canny',
  'crafty',
  'ingenious',
  'genius',
  'keen',
  'knowledgeable',
  'resourceful',
  'exceptional',
  'genial',
  'quick-witted',
  'sharp-witted',
  'nimble',
  'intuitive',
  'masterly',
  'enlightened',
  'thoughtful',
  'masterful'
];

// eslint-disable-next-line no-shadow
export enum DATA_VIEW_FILTER {
  CASES = 'cases',
  ENTRIES = 'entries',
  PIPELINE = 'pipeline'
}

export const DATA_FILTERS = [
  {
    id: 1,
    label: 'Cases',
    value: DATA_VIEW_FILTER.CASES,
    icon: 'folder'
  },
  {
    id: 2,
    label: 'All entries',
    value: DATA_VIEW_FILTER.ENTRIES,
    icon: 'file'
  },
  {
    id: 3,
    label: 'Pipeline',
    value: DATA_VIEW_FILTER.PIPELINE,
    icon: 'bars-progress'
  }
];

/**
 * Query parameters that open the form entry as a dialog over the view the user is already on, instead of navigating to
 * the entry route. Kept in the query so the underlying route — and therefore that view — stays mounted, while the URL
 * still supports deep-linking, refresh and the back button.
 *
 * These are the same names the `/investigation` and e-consent deep links already use for the same identifiers
 * (see `stores/login.ts`), so a reader only has to learn them once.
 */
export const ENTRY_DIALOG_QUERY = {
  form: 'formId',
  case: 'caseId',
  entry: 'entryId'
} as const;

//local storage keys
export const DATA_VIEW_FILTER_KEY = 'casesViewFilter';

export const SIDEBAR_COLLAPSED_KEY = 'sidebarCollapsed';

/**
 * Variable names per study, so the perfusion skeleton can draw the real row labels on a second
 * visit rather than blank bars. See `@/models/perfusionSkeleton`.
 */
export const PERFUSION_ROW_LABELS_KEY = 'perfusionRowLabels';

export const API_ERROR_CODES = {
  ANONYMOUS_RESPONSES_NOT_ALLOWED: 'ANONYMOUS_RESPONSES_NOT_ALLOWED'
};

/**
 * Shown as a notification title when a push carries a body but no title.
 *
 * Duplicated as `DEFAULT_NOTIFICATION_TITLE` in `src/firebase-messaging-sw.js`, which is built as a
 * standalone service worker and cannot import from here — keep the two in step.
 */
export const DEFAULT_NOTIFICATION_TITLE = 'Studypages Data';

/**
 * Where the mail-client channel addresses its message.
 *
 * The API's own `SUPPORT_REPORT_RECIPIENTS` is what `POST support/error-report` mails, and that list
 * is deliberately server-side — this constant covers only what the browser composes itself: the
 * "Email support instead" button and the pre-app bootstrap fallback, neither of which can reach the
 * API.
 */
export const SUPPORT_EMAIL = 'support@studypages.com';

/**
 * Base for the Sentry issue search we put in a support email, so a reference id becomes a link.
 * Org and project match `sentryVitePlugin` in vite.config.ts.
 */
export const SENTRY_ORG_URL = 'https://yuzu-labs.sentry.io';

export const DATE_FORMAT_1 = 'dd MMM yyyy, hh:mm';
export const DATE_FORMAT_2 = 'dd MMM, hh:mm';
export const DATE_FORMAT_3 = 'dd-MMM-yyyy hh:mm';
export const DATE_FORMAT_4 = 'dd-MMM-yyyy';
export const DATE_FORMAT_5 = 'dd-MM-yy hh:mm';
export const DATE_FORMAT_6 = 'dd-MM-yy';
export const DATE_FORMAT_7 = 'HH:mm MM/dd/yy ';

export const DATE_FORMATS = [
  {
    label: 'International Date Formats',
    items: [
      { label: 'yyyy-MM-dd', value: 'yyyy-MM-dd' },
      { label: 'yyyy/MM/dd', value: 'yyyy/MM/dd' },
      { label: 'dd-MM-yyyy', value: 'dd-MM-yyyy' },
      { label: 'dd/MM/yyyy', value: 'dd/MM/yyyy' },
      { label: 'MM-dd-yyyy', value: 'MM-dd-yyyy' },
      { label: 'MM/dd/yyyy', value: 'MM/dd/yyyy' },
      { label: 'yyyy.MM.dd', value: 'yyyy.MM.dd' },
      { label: 'dd.MM.yyyy', value: 'dd.MM.yyyy' },
      { label: 'MM.dd.yyyy', value: 'MM.dd.yyyy' },
      { label: 'yyyyMMdd', value: 'yyyyMMdd' },
      { label: 'ddMMyyyy', value: 'ddMMyyyy' },
      { label: 'MMddyyyy', value: 'MMddyyyy' }
    ]
  },
  {
    label: 'Expanded and Abbreviated Formats',
    items: [
      { label: 'MMMM dd, yyyy', value: 'MMMM dd, yyyy' },
      { label: 'MMM dd, yyyy', value: 'MMM dd, yyyy' },
      { label: 'dd MMMM yyyy', value: 'dd MMMM yyyy' },
      { label: 'dd MMM yyyy', value: 'dd MMM yyyy' },
      { label: 'yyyy MMMM dd', value: 'yyyy MMMM dd' },
      { label: 'yyyy MMM dd', value: 'yyyy MMM dd' },
      { label: 'dd MMMM yyyy', value: 'dd MMMM yyyy' },
      { label: 'MMMM dd, yyyy', value: 'MMMM dd, yyyy' }
    ]
  },
  {
    label: 'Compact formats',
    items: [
      { label: 'yyyyMMdd', value: 'yyyyMMdd' },
      { label: 'ddMMyyyy', value: 'ddMMyyyy' },
      { label: 'MMddyyyy', value: 'MMddyyyy' }
    ]
  },
  {
    label: 'Other Regional formats',
    items: [
      { label: 'dd.MM.yyyy', value: 'dd.MM.yyyy' },
      { label: 'yyyy.MM.dd', value: 'yyyy.MM.dd' },
      { label: 'MM.dd.yyyy', value: 'MM.dd.yyyy' },
      { label: 'dd-MM-yy', value: 'dd-MM-yy' },
      { label: 'yy-MM-dd', value: 'yy-MM-dd' },
      { label: 'yy/MM/dd', value: 'yy/MM/dd' }
    ]
  }
];

export const FORM_IMPORT_FIELD_HEADERS = [
  'identifier',
  'type',
  'label',
  'description',
  'conditions',
  'options',
  'default',
  'formulaString',
  'variableName',
  'archivedAt'
];

// DEEP LINK ACTIONS
// eslint-disable-next-line no-shadow
export enum DEEPLINK_ACTIONS {
  NON_USER_JOIN_STUDY='NON-USER/JOIN_STUDY',
  USER_JOIN_STUDY='USER/JOIN_STUDY',
  PUBLIC_LINK_JOIN_STUDY='PUBLIC_LINK/JOIN_STUDY'
}

// eslint-disable-next-line no-shadow
export enum REDIRECTION_ACTIONS {
  ACTION_STUDY_REDIRECT='study-redirect',
  ACTION_MOBILE_LOGIN = 'mobile-redirect',
  ACTION_MOBILE_LOGIN_ANDROID = 'mobile-redirect-android',
  ACTION_MOBILE_LOGIN_SPDATA = 'mobile-redirect-spdata',
  ACTION_MOBILE_LOGIN_PUMP = 'mobile-redirect-pump',
  ACTION_ECONSENT = 'econsent',
  ACTION_JOIN_STUDY = 'join-study'
}

export const GRAPH_TYPES = [
  {
    type: 'bar',
    label: 'Bar - Frequency of a Choice Field',
    icon: {
      icon: 'chart-column',
      style: 'far'
    }
  },
  {
    type: 'pie',
    label: 'Pie - Frequency of a Choice Field',
    icon: {
      icon: 'chart-pie',
      style: 'far'
    }
  },
  {
    type: 'frequency',
    label: 'Line - Frequency of Entries over Time (per User)',
    icon: {
      icon: 'chart-line',
      style: 'far'
    }
  },
  {
    type: 'line',
    label: 'Line - Number Field Values over Time',
    icon: {
      icon: 'chart-line',
      style: 'far'
    }
  },
  {
    type: 'lineChoice',
    label: 'Line - Frequency of Choice Field over Time',
    icon: {
      icon: 'chart-line',
      style: 'far'
    }
  }
  /** TODO: Enable this once we have the functionality implementation for this
   * {
    type: 'basic',
    label: 'Basic Statistical Analysis of a Number Field',
    icon: {
      icon: 'table',
      style: 'far'
    }
  } */
];

export const VueTelInputDefaultConfig = {
  mode: 'international',
  defaultCountry: 'US',
  autoFormat: true,
  autoDefaultCountry: false,
  validCharactersOnly: true
};

/**
 * The perfusion graph palette: production's hues, one band per cohort.
 *
 * ENG-8153 desaturated these — ink `#16181D`, slate `#4C6FA5`, ochre `#B4762C`, and one
 * blue-purple for every intervention — on the grounds that the old hues buried the active
 * liver. Held up against the production graph, that reason does not survive the port. What
 * buried the liver was *four* translucent layers per plot: a 50% CI band and a 25% data band
 * for each of two cohorts, mixing to brown where they overlapped. One band per cohort is the
 * change that fixed it and it stays. The hues were not the problem, so they are back at the
 * values a surgeon has read this dashboard in since it shipped.
 *
 * A cohort's one band is drawn from its *wider* range, so it takes the alpha the outer band
 * carried (25%) rather than the CI band's 50%: at 50% a band that wide reads as a filled area
 * rather than as spread.
 */
export const PUMP_GRAPH_COLORS = {
  ACTIVE_LIVER: '#800080',
  PUMP_MEAN: '#0000FF',
  PUMP_BAND: 'rgba(30, 144, 255, 0.25)',
  CENTER_MEAN: '#FF714B',
  CENTER_BAND: 'rgba(240, 161, 80, 0.25)'
};

/**
 * One hue per intervention, keyed exactly as `INTERVENTION_SYMBOLS` below is, and the same
 * values production draws.
 *
 * Hue and shape both, where ENG-8153 had shape alone. Shape is the half that still works at
 * 390px, in grayscale and for a red-green reader; hue is what makes five entries quick to tell
 * apart in a legend on a desktop. Neither is load-bearing on its own.
 */
export const INTERVENTION_COLORS = {
  BICARBONATE: '#FF0000',
  GLUCOSE_BOLUS: '#008000',
  GLUCOSE_INFUSION: '#005F00',
  TPN_BOLUS: '#FFA500',
  TPN_INFUSION: '#FF8C00'
};

/**
 * The chart's own furniture — axis labels, grid lines, the perfusion-start line. Shared by both
 * option builders so the perfusion graphs and the analytics charts read as one set of charts.
 */
export const CHART_AXIS_COLORS = {
  /** The perfusion-start line, and any axis text that should read as ink rather than as chrome. */
  INK: '#16181D',
  /** Axis labels and names: present, but never competing with the data. */
  MUTED: '#5A616E',
  GRID_LINE: 'rgba(22, 24, 29, 0.08)'
};

/**
 * Stroke widths that put the active liver in front of its cohorts. The gap is deliberate and
 * wider than it looks on a desktop: at 390px a 1px difference is not a difference.
 */
export const PUMP_GRAPH_LINE_WIDTH = {
  ACTIVE_LIVER: 2.5,
  COHORT: 1.5
};

/**
 * One shape per intervention, alongside its hue in `INTERVENTION_COLORS` above. These are
 * ECharts symbol names; a rename here changes what a surgeon reads off the legend, so the
 * legend and the series take their symbol from this one place.
 */
export const INTERVENTION_SYMBOLS = {
  BICARBONATE: 'diamond',
  GLUCOSE_BOLUS: 'triangle',
  GLUCOSE_INFUSION: 'circle',
  TPN_BOLUS: 'rect',
  TPN_INFUSION: 'emptyCircle'
};

/**
 * The two infusions run as flat lines a step apart, so the marker is the smaller half of what
 * tells them apart — filled against hollow at 8px is a weak pair on its own. The line carries
 * the rest: glucose solid, TPN dashed.
 */
export const INTERVENTION_LINE_DASH = {
  GLUCOSE_INFUSION: false,
  TPN_INFUSION: true
};
